import { Link } from 'wouter';

const logoFooter = '/assets/ALWAYS_logo_Web_RGB_NEG.png';

export default function Footer() {
  return (
    <footer className="py-8 px-4" style={{ background: '#0a2a36' }}>
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-4">
        <img src={logoFooter} alt="Allwayswithyou" className="w-36 h-auto opacity-80" />
        <nav className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-sm text-slate-500">
          <Link href="/privacy-policy" className="hover:text-slate-300 transition-colors" data-testid="link-privacy-policy">Privacy Policy</Link>
          <Link href="/terms-conditions" className="hover:text-slate-300 transition-colors" data-testid="link-terms-conditions">Terms &amp; Conditions</Link>
          <Link href="/cookie-policy" className="hover:text-slate-300 transition-colors" data-testid="link-cookie-policy">Cookie Policy</Link>
          <Link href="/company-info" className="hover:text-slate-300 transition-colors" data-testid="link-company-info">Company Information</Link>
        </nav>
        <p className="text-slate-600 text-xs">© 2026 Allwayswithyou. All rights reserved.</p>
      </div>
    </footer>
  );
}
